<template>
  <div>
    <Breadcrumbs main="Rutas" title="Rutas"/>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="pull-right">
                <b-button class="mr-2" variant="primary" size="sm" v-on:click="reloadTable">
                  <i class="fa fa-refresh"></i> Actualizar
                </b-button>
                <b-button class="mr-2" variant="success" size="sm" :to="{name: 'RouteForm'}">
                  <i class="fa fa-map-marker"></i> Agregar ruta
                </b-button>
                <b-button variant="success" size="sm" :to="{name: 'RouteDrawForm'}">
                  <i class="fa fa-map-marker"></i> Dibujar rutas
                </b-button>
              </div>
            </div>
            <div class="card-body">
              <form class="form-inline d-flex mx-1 justify-content-end"
                    @submit.stop.prevent="">
                <div class="input-group">
                  <input type="search" placeholder="Buscar" class="form-control"
                         v-model="datatableConfig.quickSearch" v-on:change="doSearch">
                  <div class="input-group-append">
                    <button type="submit" class="btn btn-outline-secondary">
                      <i class="mdi mdi-magnify" /> Buscar
                    </button>
                  </div>
                </div>
              </form>
              <div class="datatable-vue">
                <vdtnet-table
                        ref="table"
                        :fields="datatableConfig.fields"
                        :opts="datatableConfig.options"
                        @deleteObject="deleteObject"
                        @startRoute="startRoute"
                        @stopRoute="stopRoute"
                        @displayModalMap="displayModalMap"
                        @editObject="editObject"
                        @displayModalInfoDispatch="displayModalInfoDispatch"
                        @displayVoucher="displayVoucher"
                >
                </vdtnet-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="map-route" centered size="lg" title="Mapa de ruta" ok-title="Cerrar" ok-only class="theme-modal">
      <GmapMap  style="width: 100%; height: 500px" ref="mapRef"
                :center="optionsMap.center"
                :zoom="optionsMap.zoom"
                v-if="datatableOptions.items"
      >
        <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false"></gmap-info-window>
        <gmap-marker :key="i" v-for="(m,i) in markers" :position="m.position" :clickable="true" @click="toggleInfoWindow(m,i)"></gmap-marker>
      </GmapMap>
      <div class="offset-5" v-else>
        <span class="rotate dotted"></span>
      </div>
    </b-modal>
    <b-modal id="info-dispatch" centered size="lg" title="Despachos de la ruta" ok-title="Cerrar" ok-only class="theme-modal">
      <div v-if="datatableOptions.items">
        <b-row>
          <b-col md="12">
            <b-input-group class="datatable-btn">
              <b-form-input v-model="datatableOptions.filter" placeholder="Buscar..."></b-form-input>
            </b-input-group>
          </b-col>
        </b-row>
        <div class="table-responsive datatable-vue">
          <b-table
                  show-empty
                  stacked="md"
                  :items="datatableOptions.items"
                  :fields="datatableOptions.tablefields"
                  :filter="datatableOptions.filter"
                  :current-page="datatableOptions.currentPage"
                  :per-page="datatableOptions.perPage"
                  @filtered="onFiltered"
          >
            <template v-slot:cell(status)="data">
              <span class="badge badge-warning" v-if="data.item.status === '0'">{{statusDispatch.find(item => item['id'] === data.item.status).name}}</span>
              <span class="badge badge-alert" v-else-if="data.item.status === '300'">{{statusDispatch.find(item => item['id'] === data.item.status).name}}</span>
              <span class="badge badge-primary" v-else-if="['4', '280', '220'].includes(data.item.status)">{{statusDispatch.find(item => item['id'] === data.item.status).name}}</span>
              <span class="badge badge-success" v-else-if="['1', '290', '300', '310'].includes(data.item.status)">{{statusDispatch.find(item => item['id'] === data.item.status).name}}</span>
              <span class="badge badge-alert" v-else-if="['50', '60', '250'].includes(data.item.status)">{{statusDispatch.find(item => item['id'] === data.item.status).name}}</span>
              <span class="badge badge-danger" v-else-if="syncStatusDispatch.includes(data.item.status)">{{statusDispatch.find(item => item['id'] === data.item.status).name}}</span>
            </template>
            <template v-slot:cell(actions)="data">
              <span class="badge badge-primary" v-if="['0', '1', '290', '300', '310'].includes(data.item.status)">Sin acciones</span>
              <a href="javascript:void(0);" title="Cambiar estado" v-on:click="displayModalEditDispatch(data.item)" v-else><span class="badge badge-warning"><i class="fa fa-send"></i></span></a>
            </template>
          </b-table>
        </div>
        <b-col md="6" class="my-1">
          <b-pagination
                  v-model="datatableOptions.currentPage"
                  :total-rows="datatableOptions.totalRows"
                  :per-page="datatableOptions.perPage"
                  class="my-0"
          ></b-pagination>
        </b-col>
      </div>
      <div class="offset-5" v-else>
        <span class="rotate dotted"></span>
      </div>
    </b-modal>
    <b-modal id="edit-status" centered title="Editar estado" ok-title="Cambiar Estado" cancel-title="Cerrar" @ok="updateStatusDispatch" class="theme-modal">
      <div class="" v-if="dispatchEdit">
        <p class="text-center">
          Estás a punto de modificar el estádo del despacho <b>{{this.dispatchEdit.code}}</b>.
        </p>
        <p class="text-center">
          Estado actual:
          <span class="badge badge-warning" v-if="dispatchEdit.status === '0'">{{statusDispatch.find(item => item['id'] === dispatchEdit.status).name}}</span>
          <span class="badge badge-alert" v-else-if="dispatchEdit.status === '300'">{{statusDispatch.find(item => item['id'] === dispatchEdit.status).name}}</span>
          <span class="badge badge-success" v-else-if="['1', '290', '300', '310'].includes(dispatchEdit.status)">{{statusDispatch.find(item => item['id'] === dispatchEdit.status).name}}</span>
          <span class="badge badge-primary" v-else-if="['4', '280', '220'].includes(dispatchEdit.status)">{{statusDispatch.find(item => item['id'] === dispatchEdit.status).name}}</span>
          <span class="badge badge-alert" v-else-if="['50', '60', '250'].includes(dispatchEdit.status)">{{statusDispatch.find(item => item['id'] === dispatchEdit.status).name}}</span>
          <span class="badge badge-warning" v-else-if="dispatchEdit.status === '0'">{{statusDispatch.find(item => item['id'] === dispatchEdit.status).name}}</span>
          <span class="badge badge-danger" v-else-if="syncStatusDispatch.includes(dispatchEdit.status)">{{statusDispatch.find(item => item['id'] === dispatchEdit.status).name}}</span>
        </p>
        <div class="col-md-12 mb-3">
          <label>Nuevo estado (requerido)</label>
          <multiselect placeholder="Selecciona un nuevo estado" id="type_id"
                       label="name" track-by="id"
                       deselectLabel="Click para eliminar" selectLabel="Seleccionar"
                       v-model="formDispatchEdit.status.value" :options="formDispatchEdit.status.options"
                       :searchable="true" :close-on-select="true" :show-labels="true" :allow-empty="false">
            <template slot="noResult">No se encontraron elementos, por favor, cambie el filtro de búsqueda.</template>
          </multiselect>
          <b-form-invalid-feedback :state="formDispatchEdit.status.is_valid">{{formDispatchEdit.status.message_error}}</b-form-invalid-feedback>
        </div>
        <div class="col-md-12 mb-3">
          <label for="stock_id">Razón del cambio (requerido)</label>
          <b-form-textarea rows="3"
                           v-model="formDispatchEdit.observation.value"></b-form-textarea>
          <b-form-invalid-feedback :state="formDispatchEdit.observation.is_valid">{{formDispatchEdit.observation.message_error}}</b-form-invalid-feedback>
        </div>
      </div>

    </b-modal>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
  import $ from 'jquery';
  import VdtnetTable from 'vue-datatables-net';
  import 'datatables.net-bs4';
  import utils from '../../../utils';
  import Multiselect from "vue-multiselect";
  import axios from "axios";

  window.jQuery = $;

  export default {
    components: {
      Multiselect,
      VdtnetTable
    },
    data(){
      return {
        // PARA VER LA ÚLTIMA RUTA DESPLEGADA
        lastRouteIdDisplay: null,
        datatableConfig : {
          options: {
            lengthMenu: [10, 25, 50],
            pageLength: 10,
            lengthChange: false,
            processing: true,
            serverSide: true,
            searchDelay: 500,
            fixedHeader: true,
            responsive: true,
            ajax: {
              url: axios.defaults.baseURL + '/api/route/v1.0/route_table/?format=datatables',
              type: "GET",
              headers: {
                Authorization: 'JWT ' + localStorage.getItem('token')
              },
              dataSrc: (json) => {
                return json['data'];
              }
            },
            language: {
              decimal: "",
              emptyTable: "No hay información",
              info: "Mostrando _START_ a _END_ de _TOTAL_ Entradas",
              infoEmpty: "Mostrando 0 to 0 of 0 Entradas",
              infoFiltered: "(Filtrado de _MAX_ total entradas)",
              infoPostFix: "",
              thousands: ",",
              lengthMenu: "Mostrar _MENU_ Entradas",
              loadingRecords: "Cargando...",
              processing: "Procesando...",
              search: "Buscar:",
              zeroRecords: "Sin resultados encontrados",
              paginate: {
                first: "Primero",
                last: "Ultimo",
                next: "Siguiente",
                previous: "Anterior"
              }
            },
            "drawCallback": function () {
              // const num_row = $('.dataTables_length');
              $('div.vdtnet-container').removeClass('table-responsive');
              // num_row.find('select').removeClass('custom-select form-control');
              $('.dataTables_paginate').addClass('pull-right mt-2');
              $('.dataTables_info').addClass('mt-2');
            },
          },
          fields: {
            id: {
              data: 'id',
              visible: false,
              searchable: false,
            },
            // routetrajectory_set: {
            //   data: 'routetrajectory_set',
            //   visible: false,
            //   searchable: false,
            // },
            date_register: {
              name: 'date_register',
              label: 'Fecha de registro',
              data: 'date_register',
              sortable: true,
            },
            worker: {
              name: 'worker.user.first_name',
              label: 'Conductor',
              data: 'worker',
              sortable: true,
            },
            vehicle: {
              name: 'vehicle.patent',
              label: 'Vehículo',
              data: 'vehicle',
              sortable: true,
            },
            date_start: {
              name: 'date_start',
              label: 'Fecha de inicio',
              data: 'date_start',
              sortable: true,
              render: function (data, type, row){
                return (row['date_start'] !== null) ? row['date_start'] : 'No se ha proporcionado información.';
              }
            },
            date_end: {
              name: 'date_end',
              label: 'Fecha de finalización',
              data: 'date_end',
              sortable: true,
              render: function (data, type, row){
                return (row['date_end'] !== null) ? row['date_end'] : 'No se ha proporcionado información.';
              }
            },
            status: {
              name: 'status',
              label: 'Estado',
              data: 'status',
              render: function (data, type, row) {
                let name = utils.statusRoute.find(item => item['id'] === row['status'])['name'];
                let status = '';
                if(row['status'] === 'ESP'){
                  status = `<span class="badge badge-primary">${name}</span>`;
                }
                else if(row['status'] === 'ECU'){
                  status = `<span class="badge badge-warning">${name}</span>`;
                }
                else if(row['status'] === 'FIN'){
                  status = `<span class="badge badge-success">${name}</span>`;
                }
                else if(row['status'] === 'DET'){
                  status = `<span class="badge badge-alert">${name}</span>`;
                }
                else if(row['status'] === 'CAN'){
                  status = `<span class="badge badge-danger">${name}</span>`;
                }
                return status;
              }
            },
            actions: {
              label: 'Acciones',
              isLocal: true,
              render: function (data, type, row) {
                let status = '';
                if(row['status'] === 'ESP'){
                  status =
                          '<a href="javascript:void(0);" data-action="editObject" title="Editar ruta"><span class="badge badge-primary"><i class="fa fa-pencil"></i></span></a> ' +
                          '<a href="javascript:void(0);" data-action="startRoute" title="Iniciar ruta"><span class="badge badge-success"><i class="fa fa-play"></i></span></a> ' +
                          '<a href="javascript:void(0);" data-action="deleteObject" title="Eliminar ruta"><span class="badge badge-danger"><i class="fa fa-trash"></i></span></a>';
                }
                else if(row['status'] === 'ECU'){
                  status =
                          '<a href="javascript:void(0);" data-action="stopRoute" title="Detener ruta"><span class="badge badge-alert"><i class="fa fa-stop"></i></span></a>'
                }
                return '<a href="javascript:void(0);" data-action="displayModalInfoDispatch" title="Ver despachos"><span class="badge badge-info"><i class="fa fa-info"></i></span></a> ' +
                        '<a href="javascript:void(0);" data-action="displayVoucher" title="Ver boletas"><span class="badge badge-danger"><i class="fa fa-file-pdf-o"></i></span></a> ' +
                        '<a href="javascript:void(0);" data-action="displayModalMap" title="Ver mapa"><span class="badge badge-success"><i class="fa fa-map-marker"></i></span></a> ' +
                        `${status}`;
              }
            }
          },
          quickSearch: '',
        },
        statusDispatch: utils.statusDispatch,
        syncStatusDispatch: utils.syncStatusDispatch,
        map: null,
        // LISTA DE MARCADORES
        markers: [],
        // LISTA DE DIRECTIONS RENDER
        directionsRoute: [],
        // SERVICIO DE DIRECCIÓN
        directionsService: null,
        // PARA SABER SI EL INFOWINDOWS ESTÁ ABIERTO
        infoWinOpen: false,
        infoWindowPos: null,
        currentMidx: null,
        infoOptions: {
          content: '',
          //optional: offset infowindow so it visually sits nicely on top of our marker
          pixelOffset: {
            width: 0,
            height: -35
          }
        },
        optionsMap: {
          center: {lat: -33.4488897, lng: -70.6692655},
          zoom: 11,
        },
        datatableOptions: {
          tablefields: [
            { key: 'code', label: 'Código', sortable: true},
            { key: 'tracking_code', label: 'Código de seguimiento', sortable: true},
            { key: 'client', label: 'Cliente', sortable: true},
            { key: 'dispatch_client', label: 'Cliente a despacho', sortable: true},
            { key: 'phone', label: 'Teléfono', sortable: true},
            { key: 'address', label: 'Dirección', sortable: true},
            { key: 'status', label: 'Estado', sortable: true},
            { key: 'actions', label: 'Acciones', sortable: false},
          ],
          items: null,
          filter: null,
          totalRows: 1,
          currentPage: 1,
          perPage: 10,
        },
        // DATOS DEL DESPACHO A MODIFICAR
        dispatchEdit: null,
        formDispatchEdit : {
          id: utils.defaultFields(),
          status: utils.defaultFields({
            _type: 'select',
            options: utils.statusDispatchMobile
          }),
          observation: utils.defaultFields()
        }

      }
    },
    beforeDestroy () {
      clearInterval(this.intervalTable);
    },
    mounted() {
      this.intervalTable = setInterval(() => {
        this.$refs.table.reload();
      }, utils.timeRefresh * 1000);
    },
    methods: {
      updateStatusDispatch(bvModalEvt){
        // PARA EVITAR QUE SE ESCONDA EL MODAL
        bvModalEvt.preventDefault();
        let data = {};
        let isValid = utils.generateJsonStructure(this.formDispatchEdit, data);
        // OBTENGO EL NOMBRE DEL ESTADO ANTERIOR
        const oldStatusName = utils.statusDispatch.find(item => item['id'] === this.dispatchEdit.status).name;
        if(isValid){
          this.$swal({
            title: 'Información',
            type: 'info',
            html: `Estás a punto de <b>cambiar el estado</b> del despacho <b>${this.dispatchEdit.code}</b> de <b>${oldStatusName}</b> a <b>${this.formDispatchEdit.status.value.name}</b>. Se generará un registro al momento de realizar un cambio de estado.`,
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonColor: '#28a745',
            confirmButtonText: '<i class="fa fa-thumbs-up"></i> Continuar',
            cancelButtonColor: '#dc3545',
            cancelButtonText: '<i class="fa fa-thumbs-down"></i> Cancelar',
            showLoaderOnConfirm: true,
            preConfirm: async () => {
              const path = '/api/inventory/v1.0/dispatch_status/' + data['id'] + '/';
              const response = await utils.updateObject(path, data);
              // SI SE REALIZA EL CAMBIO
              if(response){
                // ESCONDEMOS EL MODAL
                this.$bvModal.hide('edit-status');
                await this.$swal({
                  title: 'Editado',
                  type: 'success',
                  html: `Se ha cambiado el estado del despacho de manera correcta.`,
                });
                // CAMBIAMOS EL ESTADO
                this.dispatchEdit.status = data['status'];
                // ACTUALIZAMOS LA TABLA
                this.reloadTable();
              }
            }
          });
        }
      },
      reloadTable() {
        // ELIMINAOS EL INTERVALO
        clearInterval(this.intervalTable);
        // RECARGAMOS
        this.$refs.table.reload();
        // GENERAMOS EL INTERVALO
        this.intervalTable = setInterval(() => {
          this.$refs.table.reload();
        }, utils.timeRefresh * 1000);
      },
      doSearch() {
        this.$refs.table.search(this.datatableConfig.quickSearch);
      },
      async displayModalMap(row){
        await this.getRouteTrajectory(row['id']);
        await this.$bvModal.show('map-route');
        await this.$refs.mapRef.$mapPromise.then((map) => {
          this.map = map;
        });
        // PARA OBTENER EL VALOR DE LA VARIABLE GOOGLE
        this.$gmapApiPromiseLazy().then(() => {
          // GENERAMOS EL SERVICIO
          if(this.directionsService === null){
            this.directionsService = new google.maps.DirectionsService;
          }
          // CONTADOR DE LA RUTA
          let countDispatch = 1;
          // VACÍO LOS MARCADORES DEL MAPA
          this.markers = [];
          // VACÍO LAS RUTAS DESPEGLADAS
          this.directionsRoute.forEach((item) => item.setMap(null));
          this.directionsRoute = [];
          // COMO PUEDO GENERAR RUTAS DE 25 PUNTOS, GENERO GRUPOS DE 25 ELEMENTOS
          const subGroupNumber = Math.ceil((this.datatableOptions.items.length / 25));
          // GENERO UN FOR QUE RECORRE CADA SUBGRUPO
          for(let group = 0; group < subGroupNumber; group++){
            // GENERO EL SUB ARREGLO
            const subGroup =  this.datatableOptions.items.slice(group * 24, (group * 24) + 25);
            // GENEROE L OBJETO QUE DIBUJA LAS DIRECCIONES
            const directionsDisplay = new google.maps.DirectionsRenderer(
                    {
                      suppressMarkers: true,
                      preserveViewport: true,
                      map: this.map
                    }
            );
            // GENERO UNA LISTA CON LOS PUNTOS DE LA RUTA
            let wayPoints = [];
            this.directionsRoute.push(directionsDisplay);
            // RECORRO EL SUB GRUPO
            subGroup.forEach((item) => {
              // GENERO EL PUNTO
              const point = new google.maps.LatLng(item['lat'], item['lng']);
              // AGREGO EL PUNTO A LA RUTA
              wayPoints.push({
                location: point
              });
              // AGREGO EL MARCADOR
              this.markers.push(
                      {
                        position: {
                          lat: item['lat'],
                          lng: item['lng']
                        },
                        infoText: '<div>' +
                                `<p>N° del reccorrido: <b>${countDispatch}</b></p>` +
                                `<p>Código: <b>${item['code']}</b></p>` +
                                `<p>Código de seguimiento: <b>${item['tracking_code']}</b></p>` +
                                `<p>Cliente: <b>${item['client']}</b></p>` +
                                `<p>Cliente a despacho: <b>${item['dispatch_client']}</b></p>` +
                                `<p>Teléfono: <b>${item['phone']}</b></p>` +
                                `<p>Dirección: <b>${item['address']}</b></p>` +
                                '</div>'
                      }
              );
              countDispatch++;
            });
            this.calculateAndDisplayRoute(google, this.directionsService, directionsDisplay, wayPoints);
          }
        });
      },
      toggleInfoWindow: function(marker, idx) {
        this.infoWindowPos = marker.position;
        this.infoOptions.content = marker.infoText;

        //check if its the same marker that was selected if yes toggle
        if (this.currentMidx === idx) {
          this.infoWinOpen = !this.infoWinOpen;
        }
        //if different marker set infowindow to open and reset current marker index
        else {
          this.infoWinOpen = true;
          this.currentMidx = idx;

        }
      },
      calculateAndDisplayRoute(google, directionsService, directionsDisplay, wayPoints) {
        directionsService.route({
          origin: wayPoints[0].location,
          destination: wayPoints[wayPoints.length - 1].location,
          waypoints: wayPoints,
          optimizeWaypoints: false,
          travelMode: google.maps.TravelMode.DRIVING
        }, function(response, status) {
          if (status === google.maps.DirectionsStatus.OK) {
            directionsDisplay.setDirections(response);
          }
          else {
            window.alert('Directions request failed due to ' + status);
          }
        });
      },
      displayModalInfoDispatch(row){
        this.getRouteTrajectory(row['id']);
        this.$bvModal.show('info-dispatch');
      },
      displayVoucher(row){
        let path;
        path = `${axios.defaults.baseURL}/api/inventory/v1.0/short_voucher_dispatchs/${row['id']}/`;
        window.open(path, '_blank');
      },
      async getRouteTrajectory(id){
        // SI ES DISTINTA A LA ÚLTIMA RUTA DESPLEGADA, LA VOY BUSCAR A LA BD
        if(this.lastRouteIdDisplay !== id){
          this.lastRouteIdDisplay = id;
          // LO GENERO EN NULO PARA NO MOSTRAR LA INFORMACIÓN AÚN Y DESPLEGAR UN CIRCULO CARGANDO
          this.datatableOptions.items = null;
          const path = `/api/route/v1.0/route/${id}/`;
          await axios.get(path).then(async (response) => {
            this.datatableOptions.totalRows = response.data['routetrajectory_set'].length;
            this.datatableOptions.items = response.data['routetrajectory_set'];
          }).catch((error) => {
            console.log(error.response);
          });
        }
      },
      displayModalEditDispatch(row) {
        this.formDispatchEdit = {
          id: utils.defaultFields(),
          status: utils.defaultFields({
            _type: 'select',
            options: utils.statusDispatchMobile
          }),
          observation: utils.defaultFields()
        };
        // OBTENGO LA INFORMACIÓN DEL DESPACHO
        this.dispatchEdit = row;
        // GENERO UNA COPIA DE LOS ESTADOS
        let statusAvailable = utils.statusDispatchMobile;
        // ELIMINO EL ESTADO QUE YA SE ENCUENTRA SELECCIONADO
        statusAvailable = statusAvailable.filter(item => item.id !== row['status']);
        //  MODIFICO LAS OPCIONES A SELECCIONAR
        this.formDispatchEdit.status.options = statusAvailable;
        // AGREGAMOS LA ID DEL DESPACHO
        this.formDispatchEdit.id.value = row['dispatch'];
        this.$bvModal.show('edit-status');
      },
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.datatableOptions.totalRows = filteredItems.length;
        this.datatableOptions.currentPage = 1
      },
      async deleteObject(row){
        this.$swal({
          title: 'Información',
          type: 'info',
          html: `Estás a punto de <b>cancelar</b> la ruta asignada al conductor <b>${row['worker']}</b> con el vehículo <b>${row['vehicle']}</b>. Al <b>cancelar</b> una ruta liberarás al conductor con su vehículo y, además, las guías asignadas cambiarán del estado <b>Ruta Asignada</b> a <b>En Proceso</b>.`,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonColor: '#28a745',
          confirmButtonText: '<i class="fa fa-thumbs-up"></i> Continuar',
          cancelButtonColor: '#dc3545',
          cancelButtonText: '<i class="fa fa-thumbs-down"></i> Cancelar',
          showLoaderOnConfirm: true,
          preConfirm: async () => {
            const path = '/api/route/v1.0/delete_route/' + row['id'] + '/';
            let data = {};
            const status = await utils.updateObject(path, data);
            if(status){
              await this.$swal({
                title: 'Cancelado',
                type: 'success',
                html: `Se ha eliminado la ruta de manera correcta.`,
              });
              this.reloadTable();
            }
          }
        });
      },
      async startRoute(row){
        this.$swal({
          title: 'Información',
          type: 'info',
          html: `Estás a punto de <b>iniciar</b> la ruta asignada al conductor <b>${row['worker']}</b> con el vehículo <b>${row['vehicle']}</b>. Las guías asignadas cambiarán del estado <b>Ruta Asignada</b> a <b>En distribución</b>.`,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonColor: '#28a745',
          confirmButtonText: '<i class="fa fa-thumbs-up"></i> Continuar',
          cancelButtonColor: '#dc3545',
          cancelButtonText: '<i class="fa fa-thumbs-down"></i> Cancelar',
          showLoaderOnConfirm: true,
          preConfirm: async () => {
            const path = '/api/route/v1.0/start_route/' + row['id'] + '/';
            let data = {};
            const status = await utils.updateObject(path, data);
            if(status){
              this.reloadTable();
              await this.$swal({
                title: 'Inciada',
                type: 'success',
                html: `Se ha iniciado la ruta de manera correcta.`,
              });
            }
          }
        });
      },
      async stopRoute(row){
        this.$swal({
          title: 'Información',
          type: 'info',
          html: `Estás a punto de <b>detener</b> la ruta asignada al conductor <b>${row['worker']}</b> con el vehículo <b>${row['vehicle']}</b>. Al <b>detener</b> una ruta liberarás al conductor con su vehículo y Las guías entregadas mantendrán su estado <b>entregado</b>, para el caso contrario, éstas cambiarán del estado <b>En distribución</b> a <b>En proceso</b>`,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonColor: '#28a745',
          confirmButtonText: '<i class="fa fa-thumbs-up"></i> Continuar',
          cancelButtonColor: '#dc3545',
          cancelButtonText: '<i class="fa fa-thumbs-down"></i> Cancelar',
          showLoaderOnConfirm: true,
          preConfirm: async () => {
            const path = '/api/route/v1.0/stop_route/' + row['id'] + '/';
            let data = {};
            const status = await utils.updateObject(path, data);
            if(status){
              this.reloadTable();
              await this.$swal({
                title: 'Detenida',
                type: 'success',
                html: `Se ha detenido la ruta de manera correcta.`,
              });
            }
          }
        });
      },
      editObject(data){
        this.$router.push({'name': 'RouteFormEdit', params: { objectId: data['id'] }});
      },
    },
    computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.tablefields
                .filter(f => f.sortable)
                .map(f => {
                  return { text: f.label, value: f.key }
                })
      }
    },
  }
</script>

<style>
  table img {
    width: 100px;
    height: 100px;
  }
  .badge-alert {
    color: #FFFFff;
    background-color: #6f42c1;
  }
  .modal-lg {
    max-width: 80% !important;
  }
</style>